
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.499 1.069A6.44 6.44 0 0113.932 7.5a6.44 6.44 0 01-6.433 6.432A6.438 6.438 0 011.069 7.5a6.438 6.438 0 016.43-6.431m0-1a7.432 7.432 0 10.005 14.861A7.432 7.432 0 007.499.07z"}}),_c('circle',{attrs:{"cx":"4.329","cy":"6.795","r":".916"}}),_c('circle',{attrs:{"cx":"10.671","cy":"6.795","r":".916"}}),_c('path',{attrs:{"d":"M7.473 12.477c-.049 0-.098-.002-.146-.005-1.196-.072-1.958-1.028-1.99-1.068a.5.5 0 01.786-.619c.01.013.532.649 1.272.69.503.021 1.008-.22 1.521-.733a.5.5 0 01.707.707c-.683.682-1.405 1.028-2.15 1.028zM3.058 5.232a.25.25 0 01-.192-.41c.436-.521 1.599-1.249 2.888-.265a.251.251 0 01-.304.398c-1.233-.941-2.161.142-2.2.188a.251.251 0 01-.192.089zM11.943 5.232a.247.247 0 01-.191-.089c-.039-.046-.973-1.123-2.2-.188a.25.25 0 01-.303-.398c1.285-.983 2.45-.256 2.887.265a.25.25 0 01-.193.41z"}})])
          )
        }
      }
    